import client from "./axios";

const therapiesUrl = `${window.__env.BASE_URL}/therapies`;

export const Therapies = {
  removeTherapySchedule: (id: number | undefined) => client.delete(`${therapiesUrl}/${id}/schedule`),
  getTherapyDetail: (id: number | undefined) => client.get(`${therapiesUrl}/${id}`)
}